export default __webpack_public_path__ + "static/media/Hoc-email.a883a9eb.svg";